import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import fa from "vuetify/lib/locale/fa";
import "@mdi/font/css/materialdesignicons.css";
import ripple from "vuetify/lib/directives/ripple";
import store from '../store';
Vue.use(Vuetify, { directives: { ripple } });

const theme = {
    primary: store.state.user.color.primary,
    secondary: store.state.user.color.secondary,
    accent: store.state.user.color.accent,
    info: "#00CAE3",
    success: "#4CAF50",
    warning: "#FB8C00",
    error: "#FF5252",
};
const dark=store.state.user.dark;
export default new Vuetify({
    rtl: true,
    lang: {
        locales: { fa },
        current: "fa",
    },
    breakpoint: { mobileBreakpoint: 960 },
    icons: {
             iconfont:'mdi'
    },
    theme: {
        dark:dark,
        themes: {
            dark: theme,
            light: theme,
        },
    },
});
